module.exports = __webpack_public_path__ + "static/img/victim-teens-1.570c2f52.png";